module.exports = __webpack_public_path__ + "img/malta.e7c67a9c.svg";